import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-evaluation-edit-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type CourseEvaluationEditStore = {
    evaluation: Map<unknown, unknown>;
};

const initialState = (): CourseEvaluationEditStore => {
    return {
        evaluation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<CourseEvaluationEditStore> = {
    [actionTypes.FETCH_COURSE_EVALUATION_SUCCESS]: (state, action) => {
        return {
            evaluation: action.data,
        };
    },

    [actionTypes.DISPOSE_STORE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvaluationEditStore>(initialState(), actionsMap);
